import davideUrsoImg from '../assets/team/davide_urso.png';
import adamGaleImg from '../assets/team/adam_gale.png';
import jacobWongImg from '../assets/team/jacob_wong.jpg';

export interface TeamMember {
  id: string;
  name: string;
  role: string; // I'll infer or leave generic if not provided, but user didn't provide roles explicitly in the text, just names. I'll use "Executive" or similar, or just hide it if not needed. Actually, the text describes them. I'll put the text in 'bio'.
  // User didn't give specific titles like "CEO", just descriptions. I will omit role or extract it from text if obvious.
  // Davide: "Executive and Entrepreneur"
  // Adam: "Seasoned Entrepreneur"
  // Jacob: "Experience in construction..."
  // I'll add a 'title' field but maybe leave it blank or generic if not sure.
  // Actually, I'll just use the name and bio as requested.
  image: string;
  bio: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 'davide-urso',
    name: 'Davide Urso',
    role: 'Executive & Entrepreneur',
    image: davideUrsoImg,
    bio: 'An experienced executive and entrepreneur with a strong academic background and expertise in commodities, mining, and entertainment. He combines strategic, commercial, and technical skills with legal knowledge to manage cross-border development and complex transactions. Using his network, he promotes growth, innovation, and strategic partnerships.'
  },
  {
    id: 'adam-gale',
    name: 'Adam Gale',
    role: 'Entrepreneur & Global Trade Expert',
    image: adamGaleImg,
    bio: 'A seasoned entrepreneur, Adam has a lifelong passion for commodities and global trade. Since 1984, he has worked in Asia across manufacturing, sourcing, commodities, and mining sectors. His extensive network includes political and business contacts from around the world.'
  },
  {
    id: 'jacob-wong',
    name: 'Jacob Wong',
    role: 'Southeast Asia Specialist',
    image: jacobWongImg,
    bio: 'With extensive experience in construction, manufacturing, finance, and automotive sales, he was the first to introduce Jeep and Ram Trucks at Fiat Chrysler Automobiles (Stellantis). After living in Cambodia for over 29 years, he has strong connections with key government figures and is skilled at navigating Southeast Asia’s complex geopolitical landscape.'
  }
];
